import React from "react";
import "./AchievementCard.scss";
import { InlineIcon } from '@iconify/react';

export default function AchievementCard({cardInfo, isDark}) {
  function openUrlInNewTab(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <div className={isDark ? "dark-mode certificate-card" : "certificate-card"}>
      <div className="certificate-image-div">
        <img src={cardInfo.image} className="card-image"></img>
      </div>
      <div className="certificate-detail-div">
        <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
          {cardInfo.title}
        </h5>
        <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>
          {cardInfo.description}
        </p>
      </div>
      <div className="certificate-card-footer">
        {cardInfo.footer.map((v, i) => {
          return (
            <li
              key={i}
              className={
                isDark ? "dark-mode certificate-tag" : "software-skill-inline"
              }
              onClick={() => openUrlInNewTab(v.url)}
            >
              <span className="certificate-tag">{v.name}</span>
              <i className="certificate-icon"><InlineIcon icon={v.icon1}/></i>
              <i className="certificate-icon"><InlineIcon icon={v.icon2}/></i>
              <i className="certificate-icon"><InlineIcon icon={v.icon3}/></i>
            </li>
          );
        })}
      </div>
    </div>
  );
}
